if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartSlideOver = document.querySelector("cart-slide-over");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.dataset.express) {
          const expressInput = document.createElement("input");
          expressInput.setAttribute("type", "hidden");
          expressInput.setAttribute("name", "properties[_cl]");
          this.form.appendChild(expressInput);
          if (submitButton.dataset.expressToday) {
            const expressTodayInput = document.createElement("input");
            expressTodayInput.setAttribute("type", "hidden");
            expressTodayInput.setAttribute("name", "properties[_Vesper]");
            expressTodayInput.setAttribute("value", "store");
            this.form.appendChild(expressTodayInput);
          }
        }
        if (submitButton.dataset.nowrap) {
          const nowrapInput = document.createElement("input");
          nowrapInput.setAttribute("type", "hidden");
          nowrapInput.setAttribute("name", "properties[_sinenvolver]");
          this.form.appendChild(nowrapInput);
        }

        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        this.cartSlideOver.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-icon").classList.remove("hidden");
        const config = {
          method: "POST",
          headers: {
            Accept: "application/javascript",
          },
        };
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        const formData = new FormData(this.form);

        // console.log the formData
        for (var pair of formData.entries()) {
          console.log(pair[0] + ", " + pair[1]);
        }

        formData.append(
          "sections",
          this.cartSlideOver.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }

            this.cartSlideOver.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-icon").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".error-message");
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".error-message__copy");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

document.getElementById("brandFilter").addEventListener("change", function() {
  var brand = this.value;  // Obtener la marca seleccionada
  var url = new URL(window.location.href);  // Obtener la URL actual

  if (brand) {
    url.searchParams.set('brand', brand);  // Añadir el parámetro de marca
  } else {
    url.searchParams.delete('brand');  // Eliminar el parámetro de marca si no se selecciona ninguna
  }

  // Enviar la solicitud AJAX para actualizar los productos
  fetch(url)
    .then(response => response.text())
    .then(html => {
      // Buscar y reemplazar el contenido de los productos filtrados
      var newProducts = new DOMParser().parseFromString(html, "text/html").querySelector(".product-grid");
      var productGrid = document.querySelector(".product-grid");  // Este es el contenedor de productos actual

      // Reemplazar los productos actuales con los filtrados
      if (productGrid && newProducts) {
        productGrid.innerHTML = newProducts.innerHTML;
      }

      // También actualizamos el contador de productos si es necesario
      var newProductCount = new DOMParser().parseFromString(html, "text/html").querySelector("#ProductCount").textContent;
      if (newProductCount) {
        document.getElementById("ProductCount").textContent = newProductCount;
      }
    })
    .catch(error => {
      console.error("Error al filtrar los productos:", error);
    });
});

